<div class="chart-wrapper">
    <canvas baseChart
      [datasets]="pieChartData"
      [options]="pieChartOptions"
      [labels]="labels()"
      [legend]="pieChartLegend"
      [type]="pieChartType"
      >
    </canvas>
</div>